import React from "react";

const ChatItem = ({ chat, onClick }) => {
  return (
    <div
      onClick={onClick}
      className="swiper-groupsfollowers flex items-center justify-between p-3 !mb-4 hover:bg-gray-100 rounded cursor-pointer shadow"
    >
      <div className="flex items-center gap-3">
        <img
          src={chat.avatar}
          alt={chat.name}
          className="w-[62px] h-[62px] rounded-2xl border"
        />
        <div>
          <h4 className="font-semibold text-base text-[#000000]">{chat.name}</h4>
          <p className="text-sm text-[#797C7B]">{chat.lastMessage}</p>
           <span className="text-xs text-[#39B54A] italic">{chat.time}</span>
        </div>
      </div>
     
    </div>
  );
};

export default ChatItem;
